import { FoodsIllustrations, type FoodsIllustrationsProps } from "@foodpilot/foods";
import { getCsrPillarIconKey } from "src/utils/csrStrategyPillarIcons";

type CsrPillarIconProps = {
    icon?: string | null;
    height: number;
    width?: number;
    backgroundShape?: "circle" | "rect";
    variant?: FoodsIllustrationsProps["variant"];
};

export const CsrPillarIcon = (props: CsrPillarIconProps) => {
    const { icon, height, width = height, backgroundShape = "circle", variant = "dataviz-9" } = props;
    const iconKey = getCsrPillarIconKey(icon);

    return (
        <FoodsIllustrations
            illustration={iconKey}
            backgroundShape={backgroundShape}
            height={height}
            width={width}
            variant={variant}
        />
    );
};
